import React, { useState, useEffect } from 'react';
import {
  Grid,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  Tooltip
} from "@mui/material";
import { Autocomplete } from "@mui/lab";
import SaveIcon from '@mui/icons-material/Save';
import dayjs from "dayjs"; 
import CancelIcon from '@mui/icons-material/Cancel';
import SearchIcon from '@mui/icons-material/Search';
import { useSnackbar } from 'notistack';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { getUser } from '../../../shared/auth-service';
import {
  getDataEmployeeAbsenteeismSupport,
  GetCodeCIE
} from '../logic';

const AbsenteeismSupportDetail = (
  { 
    dataAbsenteeismIssuer,
    dataDetailAbsenteeism,
    dataTypeAbsenteeism,
    handleClose, 
    handleSave 

  }) => {
  const { enqueueSnackbar } = useSnackbar();
  const user = getUser();
  const [dni, setDni] = useState('');
  const [eps, setEps] = useState('');
  const [empresa, setEmpresa] = useState('');
  const [cargo, setCargo] = useState('');
  const [fechaIngreso, setFechaIngreso] = useState('');
  const [area, setArea] = useState('');
  const [observation, setObservation] = useState('');
  const [name, setName] = useState('');
  const [entity, setEntity] = useState('');
  const [absenceType, setAbsenceType] = useState('');
  const [absenceDetail, setAbsenceDetail] = useState('');
  const [cieCode, setCieCode] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [cieOptions, setCieOptions] = useState([]);
  const [absenteeismIssuerOptions, setAbsenteeismIssuerOptions] = useState( dataAbsenteeismIssuer ?? []);
  const [detailAbsenteeismOptions, setDetailAbsenteeismOptions] = useState(dataDetailAbsenteeism ?? []);
  const [typeAbsenteeismOptions, setTypeAbsenteeismOptions] = useState(dataTypeAbsenteeism ?? []);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const companyId = user.countryCode.split('-')[0];
  const employeeId = user.employeeId;
  const temporalId = user.temporalId;

  useEffect(() => {
    setEps(''); setName(''); setEmpresa(''); setCargo(''); setFechaIngreso(''); setArea('');
  }, [dni]);

  const fetchCIE = async (data) => {
    try {
      setLoading(true);
      var dataCIE = await GetCodeCIE(data);
      setCieOptions(dataCIE ?? []);
    } catch (error) {
      console.error("Error fetching CIE codes:", error);
    }
    setLoading(false);
  };

  const handleSearchDni = async () => {
    if (dni) {
      var dataEmployee = await getDataEmployeeAbsenteeismSupport(dni, companyId, temporalId)

      if (dataEmployee.name != undefined )
      {
        setEps(dataEmployee.eps);
        setName(dataEmployee.name);
        setEmpresa(dataEmployee.empresa);
        setCargo(dataEmployee.cargo);
        setFechaIngreso(dataEmployee.fechaIngreso);
        setArea(dataEmployee.area);
      }
      else{
        enqueueSnackbar('Colaborador no encontrado.', { variant: 'warning' });
      }
   
    } else 
      enqueueSnackbar('Ingrese un número de cédula válido.', { variant: 'warning' });
  };

  const handleObservationChange = (e) => {
    const value = e.target.value;
    setObservation(value);
  };

  const onSave = async () => {
    if (fromDate && toDate && fromDate > toDate) {
      enqueueSnackbar('La Fecha Desde debe ser menor a la Fecha Hasta.', { variant: 'warning' });
      return;
    }
  
    if (!dni || !eps || !entity || !absenceType || !absenceDetail || !fromDate || !toDate) {
      enqueueSnackbar('Todos los campos marcados con * son obligatorios.', { variant: 'error' });
      return;
    }
  
    setIsSaving(true);
  
    const formattedFromDate = dayjs(fromDate).format("YYYY-MM-DD");
    const formattedToDate = dayjs(toDate).format("YYYY-MM-DD");
  
    const data = {
      EmployeeId: dni,
      EPS: {
        Description: eps
      },
      AbsenteeismIssuer: {
        Id: entity
      },
      TypeAbsenteeism: {
        Id: absenceType
      },
      DetailAbsenteeism: {
        Id: absenceDetail
      },
      CodeCIE: {
        Id: cieCode
      },
      StartDate: formattedFromDate,
      EndDate: formattedToDate,
      Observation: observation,
      CompanyId: companyId,
      CreationUser: employeeId
    };
  
    try {
      const response = await handleSave(data);
      //console.log(response);
      if (response.data.status) {
        enqueueSnackbar(response.data.message, { variant: 'success' });
        handleClose();
      } else {
        enqueueSnackbar(response.data.message, { variant: 'error' });
      }
    } catch (error) {
      //enqueueSnackbar('Error inesperado al guardar.', { variant: 'error' });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Dialog open={true} maxWidth="md" fullWidth>
     <DialogTitle sx={{ mb: 2 }}>Documento Soporte</DialogTitle>
        <Typography variant="body2" sx={{ mb: 3, ml: 3.2, color: 'gray' }}>
          <i>Los campos marcados con * son obligatorios</i>
        </Typography>
      <DialogContent>
        <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField
            label="Cédula Colaborador *"
            type="number"
            fullWidth
            size="small"
            value={dni}
            onChange={(e) => setDni(e.target.value)}
            InputProps={{
              endAdornment: (
                <IconButton onClick={handleSearchDni}>
                  <SearchIcon />
                </IconButton>
              ),
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            label="Nombre Colaborador"
            fullWidth
            size="small"
            value={name}
            InputProps={{ readOnly: true }}
            disabled
          />
        </Grid>

        <Grid item xs={12}>
        <Tooltip title={eps} arrow>
          <TextField 
            label="EPS" 
            fullWidth 
            size="small"
            value={eps} 
            InputProps={{ 
              readOnly: true
            }} 
            disabled
          />
        </Tooltip>
        </Grid>
       
        <Grid item xs={6}>
        <Tooltip title={empresa} arrow>
          <TextField 
            label="Empresa" 
            fullWidth 
            size="small"
            value={empresa} 
            InputProps={{ 
              readOnly: true
            }} 
            disabled
          />
        </Tooltip>
        </Grid>

        <Grid item xs={6}>
        <Tooltip title={cargo} arrow>
          <TextField 
            label="Cargo" 
            fullWidth 
            size="small"
            value={cargo} 
            InputProps={{ 
              readOnly: true
            }} 
            disabled
          />
        </Tooltip>
        </Grid>
        <Grid item xs={6}>
        <Tooltip title={area} arrow>
          <TextField 
            label="Área" 
            fullWidth 
            size="small"
            value={area} 
            InputProps={{ 
              readOnly: true
            }} 
            disabled
          />
        </Tooltip>
        </Grid>
        <Grid item xs={6}>
        <Tooltip title={fechaIngreso} arrow>
          <TextField 
            label="Fecha Ingreso" 
            fullWidth 
            size="small"
            value={fechaIngreso} 
            InputProps={{ 
              readOnly: true
            }} 
            disabled
          />
        </Tooltip>
        </Grid>


        <Grid item xs={6}>
          <FormControl fullWidth size="small">
            <InputLabel id="entity-label">Entidad *</InputLabel>
            <Select
              labelId="entity-label"
              label="Entidad *"
              value={entity}
              onChange={(e) => setEntity(e.target.value)}
            >
              {absenteeismIssuerOptions.map(item => (
                <MenuItem key={item.id} value={item.id}>{item.description}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

         <Grid item xs={6}>
          <FormControl fullWidth size="small">
            <InputLabel id="absence-type-label">Tipo Ausentismo *</InputLabel>
            <Select
              labelId="absence-type-label"
              label="Tipo Ausentismo *"
              value={absenceType}
              onChange={(e) => setAbsenceType(e.target.value)}
            >
              {typeAbsenteeismOptions.map(item => (
                <MenuItem key={item.id} value={item.id}>{item.description}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>


          <Grid item xs={6}>
          <FormControl fullWidth size="small">
            <InputLabel id="absence-detail-label">Detalle Ausentismo *</InputLabel>
            <Select
              labelId="absence-detail-label"
              label="Detalle Ausentismo *"
              value={absenceDetail}
              onChange={(e) => setAbsenceDetail(e.target.value)}
            >
              {detailAbsenteeismOptions.map(item => (
                <MenuItem key={item.id} value={item.id}>{item.description}</MenuItem>
              ))}
            </Select>
          </FormControl>
          </Grid>
          <Grid item xs={6}>
            <Autocomplete
                noOptionsText="Sin resultados"
                loading={loading}
                size="small"
                id="cie-autocomplete"
                options={cieOptions}
                getOptionLabel={(option) =>
                  option && option.code && option.description
                    ? `${option.code} - ${option.description}`
                    : ""
                }
                value={cieOptions.find(opt => opt.id === cieCode) || null}
                inputValue={inputValue}
                onChange={(event, newValue) => {
                  if (newValue) {
                    setCieCode(newValue.id);
                    setInputValue(`${newValue.code} - ${newValue.description}`);
                    //console.log(cieCode + '--------' + inputValue + '->');
                    //console.log(newValue);
                  } else {
                    setCieCode(null);
                    setInputValue(""); 
                  }
                }}
                onInputChange={(event, newInputValue) => {
                  if (!event) return;

                  if (event.type === "change") {
                    setInputValue(newInputValue);
                  }
              
                  if (newInputValue.length >= 3) {
                    fetchCIE(newInputValue);
                  } else {
                    setCieOptions([]);
                  }
                }}
                isOptionEqualToValue={(option, value) => option.id === value?.id}
                onClose={() => {
                  const selectedOption = cieOptions.find(opt => opt.id === cieCode);
                  if (selectedOption) 
                    setInputValue(`${selectedOption.code} - ${selectedOption.description}`);
                }}
                renderOption={(props, option) => (
                  <li {...props} key={option.id} value={option.id}>
                    {option.code} - {option.description}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Código CIE *"
                    helperText="Ingrese al menos 3 caracteres para buscar"
                  />
                )}
             />
          </Grid>

          <Grid item xs={12}>
            <FormControl fullWidth>
              <TextField
                label="Observación"
                onChange={handleObservationChange}
                value={observation}
                //error={observation.length > 500}
                //helperText={observation.length > 500 ? "El texto no debe exceder los 500 caracteres" : ''}
              />
            </FormControl>
          </Grid>

          <Grid item xs={6}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DesktopDatePicker
                label="Fecha Desde *"
                inputFormat="DD/MM/YYYY"
                value={fromDate}
                onChange={(date) => setFromDate(date)}
                renderInput={(params) => (
                  <TextField {...params} fullWidth size="small" />
                )}
              />
            </LocalizationProvider>
          </Grid>


          <Grid item xs={6}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DesktopDatePicker
                label="Fecha Hasta *"
                inputFormat="DD/MM/YYYY"
                value={toDate}
                onChange={(date) => setToDate(date)}
                renderInput={(params) => (
                  <TextField {...params} fullWidth size="small" />
                )}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
      <Button 
            color="primary" 
            variant="contained" 
            onClick={onSave} 
            endIcon={<SaveIcon />} 
            disabled={isSaving}
          >
            {isSaving ? "Guardando..." : "Guardar"}
          </Button>
        <Button variant="outlined" onClick={handleClose} endIcon={<CancelIcon />}>
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AbsenteeismSupportDetail;
